'use strict';

angular.module('cgmemApp')
  .controller('LoginCtrl', function ($scope, $state, $stateParams, $log, User) {
    $scope.loginFailureReason = "";
    $scope.username = "";
    $scope.password = "";
    $scope.submitting = false;

    $scope.login = function() {
      $scope.submitting = true;
      $scope.loginFailureReason = "";
      User.login($scope.username, $scope.password)
        .then(function() {
            if($stateParams.redirect && $state.get($stateParams.redirect))
              $state.go($stateParams.redirect, $stateParams.stateParams)
            else
              $state.go('authenticated.profile');
        })
        .catch(function(err) {
          console.log(err)
          $scope.submitting = false;
          if(err.status >= 400 || err.status < 500)
            $scope.loginFailureReason = err.data;
          else
            $scope.loginFailureReason = "System Problem - please try again in a few minutes";
        });
    }
  });
